module.exports = __webpack_public_path__ + "img/godlo.e392da84.png";